import { AccountButtonProps } from "@omni/types/components/props/accountButton.props";
import { PageLinkComponentProps } from "@omni/ui/components/PageLink/pageLink.props";
import { attempt } from "@omni/utils/function.utils";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import AccountButtonMenu from "@/components/Account/AccountButton/accountButtonMenu.component";
import { HeaderButton } from "@/components/General/HeaderButton/headerButton.component";
import { useThunkDispatch } from "@/redux/dispatcher";
import * as CustomerModule from "@/redux/modules/api/data/customer/customer.module";
import * as CustomerSelectors from "@/redux/modules/api/data/customer/customer.selectors";
import * as HeaderSelectors from "@/redux/modules/value/header/header.selectors";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import * as SoftLoginService from "@/services/softLogin.service";
import { rewriteAccountLinksForSoftLogin } from "@/utils/account";
import { useIsClientSide } from "@/utils/hooks/isClient.hook";

const AccountButtonContainer = ({
    alerts,
    ariaLabel,
    hover,
    icon,
    invert,
    link,
    menuLinksSettings,
    redirect,
    text,
    textHidden
}: AccountButtonProps) => {
    const { t } = useGranite();
    const dispatch = useThunkDispatch();
    const mobile = useSelector(HeaderSelectors.isMobile);
    const customer = useSelector(CustomerSelectors.getCustomer);
    const isClientSide = useIsClientSide();
    const [parsedMenuLinks, setParsedMenuLinks] =
        useState<Array<PageLinkComponentProps>>();

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        if (isClientSide) {
            dispatch(CustomerModule.load());
        }
    }, [isClientSide]);

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        const isLoggedIn = !!(customer && !customer.guest);

        if (menuLinksSettings) {
            setParsedMenuLinks(
                rewriteAccountLinksForSoftLogin(
                    isLoggedIn,
                    attempt(() => JSON.parse(menuLinksSettings), undefined),
                    link
                )
            );
        }
    }, [customer]);

    let firstName;
    let isCustomer = false;
    let userIsLoggedIn = false;

    if (isClientSide) {
        firstName = SoftLoginService.getSoftLoginDetails().firstName;
        isCustomer = !!(customer && !customer.guest);
        userIsLoggedIn = isCustomer || SoftLoginService.isSoftLoggedIn();

        if (isCustomer) {
            firstName = customer?.firstName;
        }
    }

    const componentShouldInvert = isClientSide ? invert || mobile : false;

    return (
        <HeaderButton
            icon={icon}
            hover={hover}
            alerts={alerts}
            invert={componentShouldInvert}
            ariaLabel={ariaLabel}
            text={
                firstName
                    ? t("general.header.account.welcome", firstName)
                    : text
            }
            link={isCustomer ? redirect : link}
            textHidden={textHidden}
        >
            {userIsLoggedIn && <AccountButtonMenu links={parsedMenuLinks} />}
        </HeaderButton>
    );
};

export { AccountButtonContainer };
